import React, { Component, Fragment } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { THEME } from './configs/global';

import Index from './containers/IndexPage';

import iconMegabus from './assets/images/megabus/favicon.png';

const DynamicManifest = {
  short_name: THEME.NAME,
  name: THEME.TITLE,
  start_url: window.location.href,
  display: 'standalone',
  theme_color: THEME.BRAND_COLOR || '#000000',
  background_color: THEME.BRAND_COLOR || '#000000',
  icons: [
    {
      src: 'favicon.ico',
      sizes: '64x64 32x32 24x24 16x16',
      type: 'image/x-icon',
    },
  ],
};

if (THEME.SET_OF_FAVICONS) {
  DynamicManifest.icons.push(
    {
      src: 'icon-192x192.png',
      sizes: '192x192',
      type: 'image/png',
    },
    {
      src: 'icon-512x512.png',
      sizes: '512x512',
      type: 'image/png',
    }
  );
}

const stringManifest = JSON.stringify(DynamicManifest);
const blob = new Blob([stringManifest], { type: 'application/json' });
const manifestURL = URL.createObjectURL(blob);
document
  .querySelector('#my-manifest-placeholder')
  .setAttribute('href', manifestURL);

class App extends Component {
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{THEME.TITLE}</title>
          <meta name="title" content={THEME.TITLE} />
          {THEME.DESCRIPTION && (
            <meta name="description" content={THEME.DESCRIPTION} />
          )}

          {THEME.SOCIALIMAGE && (
            <meta property="og:image" content={THEME.SOCIALIMAGE} />
          )}

          {THEME.SOCIALTEXT && (
            <meta property="og:title" content={THEME.SOCIALTEXT} />
          ) && (
            <meta name="twitter:title" content={THEME.SOCIALTEXT} />
          )}
          
          {THEME.NAME === 'Megabus' && (
            <meta name="image" content={iconMegabus} />
          )}
          {THEME.NAME === 'Megabus' && (
            <meta property="og:image" content={iconMegabus} />
          )}
        </Helmet>

        <Router>
          <div className={`App ${THEME.NAME.toUpperCase()}`}>
            <Route path="/" component={Index} />
          </div>
        </Router>
      </Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js